import type { DynamicAssessmentSnapshot } from '@/entities/profile/createDynamicAssessmentSnapshot'
import type { AppState } from '@/store/rootTypes'
import type { LearningLayer } from '@/types'

type EffectiveLearningLayerState = Pick<
  AppState,
  'manualLayerOverride' | 'dynamicLayer' | 'currentStage' | 'pretestLayer' | 'profile' | 'attempts' | 'student'
>

/**
 * Resolves the official layer frozen for the current stage.
 * Dynamic assessment remains evidence for the next stage and never changes this value mid-stage.
 */
export function resolveEffectiveLearningLayer(
  state: EffectiveLearningLayerState,
  dynamicAssessment?: DynamicAssessmentSnapshot | null,
): LearningLayer {
  void dynamicAssessment

  return state.currentStage?.layer
    ?? state.manualLayerOverride
    ?? state.profile?.recommendedLevel
    ?? state.pretestLayer
    ?? state.student.layer
    ?? state.dynamicLayer
    ?? 'B'
}
